import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/tipoadquisicion';

const tipoAdquisicionApi = {
    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching tipos de adquisición:', error);
            return [];
        }
    },
};

export default tipoAdquisicionApi;
